/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Share_More_MembersInputs */

const en_team_share_more_members = /** @type {(inputs: Team_Share_More_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const fr_team_share_more_members = /** @type {(inputs: Team_Share_More_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const de_team_share_more_members = /** @type {(inputs: Team_Share_More_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const it_team_share_more_members = /** @type {(inputs: Team_Share_More_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const ru_team_share_more_members = /** @type {(inputs: Team_Share_More_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const es_team_share_more_members = /** @type {(inputs: Team_Share_More_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const zh_cn2_team_share_more_members = /** @type {(inputs: Team_Share_More_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const ja_team_share_more_members = /** @type {(inputs: Team_Share_More_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const hi_team_share_more_members = /** @type {(inputs: Team_Share_More_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

const pt_pt2_team_share_more_members = /** @type {(inputs: Team_Share_More_MembersInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.count}`)
};

/**
* | output |
* | --- |
* | "+{count}" |
*
* @param {Team_Share_More_MembersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_more_members = /** @type {((inputs: Team_Share_More_MembersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_More_MembersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_share_more_members(inputs)
	if (locale === "de") return de_team_share_more_members(inputs)
	if (locale === "it") return it_team_share_more_members(inputs)
	if (locale === "ru") return ru_team_share_more_members(inputs)
	if (locale === "es") return es_team_share_more_members(inputs)
	if (locale === "zh-CN") return zh_cn2_team_share_more_members(inputs)
	if (locale === "ja") return ja_team_share_more_members(inputs)
	if (locale === "hi") return hi_team_share_more_members(inputs)
	if (locale === "pt-PT") return pt_pt2_team_share_more_members(inputs)
	return en_team_share_more_members(inputs)
});